<template>
    <b-card-body no-body>
        <b-form-row class="pt-3">
            <b-col cols="12">
                <b-row>
                    <b-col cols="8" class="d-flex justify-content-center align-items-center">
                        <lg-form-input v-model="nome" label="Nome:" @keyup.enter="buscarConfiguracao" />
                    </b-col>

                    <b-col cols="4" class="d-flex justify-content-center align-items-center">
                        <b-button id="btnBuscar" class="mr-2 my-2" size="sm" pill variant="primary"
                            @click="buscarConfiguracao">
                            <div class="btn-size-alinhamento">

                                <b-icon icon="search" />
                                <b-tooltip target="btnBuscar" title="Buscar"></b-tooltip>
                            </div>
                        </b-button>

                        <b-button id="btnLimpar" class="mr-2 my-2" size="sm" pill variant="primary"
                            @click="limparFiltro">
                            <div class="btn-size-alinhamento">

                                <b-icon icon="eraser" />
                                <b-tooltip target="btnLimpar" title="Limpar"></b-tooltip>
                            </div>
                        </b-button>
                    </b-col>
                </b-row>
            </b-col>
        </b-form-row>

        <b-table responsive small class="mt-2" :hover="true" show-empty :items="configuracoes" :fields="camposTabela"
            :busy="busy">
            <template #table-busy>
                <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> Carregando...</strong>
                </div>
            </template>

            <template #empty>
                <p>Nenhum registro encontrado</p>
            </template>
            <template #cell(acoes)="row">
                <b-button id="btnEditar" size="sm" variant="primary" @click="editar(row.item)">

                    <b-icon icon="pencil-square" />
                    <b-tooltip target="btnEditar" title="Editar..."></b-tooltip>
                </b-button>
            </template>
            <template #cell(valorPropriedade)="row">
                {{ row.item.valorPropriedade == null ? "Não se aplica" : (row.item.valorPropriedade === 0 ? "Não" :
                    row.item.valorPropriedade) }}
            </template>
        </b-table>
        <AlmoxarifadoCentralModal v-if="showAlmoxarifadoCentralModal" :configuracao="configuracaoEdit"
            @salvo="onConfiguracaoSalva" @close="onModalClose" />
        <EmailConfigModal v-if="showEmailConfigModal" :configuracao="configuracaoEdit" @salvo="onConfiguracaoSalva"
            @close="onModalClose" />
        <ConfiguracaoSimplesModal v-if="showConfiguracaoSimplesModal" :configuracao="configuracaoEdit"
            @salvo="onConfiguracaoSalva" @close="onModalClose" />
        <DepartamentoResponsavelModal v-if="showDepartamentoResponsavelModal" :configuracao="configuracaoEdit"
            @salvo="onConfiguracaoSalva" @close="onModalClose" />
        <AlertaProcessoModal v-if="showAlertaProcessoModal" :configuracao="configuracaoEdit"
            @salvo="onConfiguracaoSalva" @close="onModalClose" />
        <PrazoItemBemPermanenteModal v-if="showPrazoItemBemPermanenteModal" :configuracao="configuracaoEdit"
            @salvo="onConfiguracaoSalva" @close="onModalClose" />
        <ConfiguracaoGeralModal v-if="showConfiguracaoGeralModal" :configuracao="configuracaoEdit"
            @salvo="onConfiguracaoSalva" @close="onModalClose" />
        <ConfiguracaoGeralLogicaModal v-if="showConfiguracaoGeralLogicaModal" :configuracao="configuracaoEdit"
            @salvo="onConfiguracaoSalva" @close="onModalClose" />
        <PatrimonioInventarioAnualModal v-if="showPatrimonioInventarioAnualModal" :configuracao="configuracaoEdit"
            @salvo="onConfiguracaoSalva" @close="onModalClose" />
        <EstadoConservacaoIbpModal v-if="showEstadoConservacaoIbpModal" :configuracao="configuracaoEdit"
            @salvo="onConfiguracaoSalva" @close="onModalClose" />
        <ManutencaoPatrimonialModal v-if="showManutencaoPatrimonialModal" :configuracao="configuracaoEdit"
            @salvo="onConfiguracaoSalva" @close="onModalClose" />
        <AlterarSenhaUsuarioModal v-if="showAlterarSenhaUsuarioModal" :configuracao="configuracaoEdit"
            @salvo="onConfiguracaoSalva" @close="onModalClose" />
        <EmpresaResponsavelSistemaModal v-if="showEmpresaResponsavelSistemaModal" :configuracao="configuracaoEdit"
            @salvo="onConfiguracaoSalva" @close="onModalClose" />
        <FrequenciaEnvioEmailModal v-if="showFrequenciaEnvioEmailModal" :configuracao="configuracaoEdit"
            @salvo="onConfiguracaoSalva" @close="onModalClose" />
        <ConfiguracaoCamposObrigatoriosProdutoModal v-if="showConfiguracaoCamposObrigatoriosProdutoModal"
            :configuracao="configuracaoEdit" @salvo="onConfiguracaoSalva" @close="onModalClose" />

        <PainelConfiguracaoUsuarioForm @close="fecharPainelConfiguracaoUsuarioForm"
            v-if="showPainelConfiguracaoUsuarioForm" :configuracao="configuracaoEdit" @salvo="onConfiguracaoSalva" />

        <ConfiguracaoGeralParametros v-if="showConfiguracaoGeralParametros" :configuracao="configuracaoEdit"
            @salvo="onConfiguracaoSalva" @close="onModalClose" />

        <ConfiguracaoGeralParametrosDashboard v-if="showConfiguracaoGeralParametrosDashboard" :configuracao="configuracaoEdit"
            @salvo="onConfiguracaoSalva" @close="onModalClose" />


    </b-card-body>
</template>

<script>
import ConfiguracaoSistemaService from "@/core/api/ConfiguracaoSistemaService";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import { ListResourceMixin } from "@/core/mixins/resource";
import ConfirmMixin from "@/core/mixins/confirm";
import EstadoConservacaoIbpModal
    from "@/modules/administrador/painel-de-configuracao/components/modal/EstadoConservacaoIbpModal.vue";
import AlmoxarifadoCentralModal
    from "@/modules/administrador/painel-de-configuracao/components/modal/AlmoxarifadoCentralModal.vue";
import ManutencaoPatrimonialModal
    from "@/modules/administrador/painel-de-configuracao/components/modal/ManutencaoPatrimonialModal.vue";
import ConfiguracaoGeralModal
    from "@/modules/administrador/painel-de-configuracao/components/modal/ConfiguracaoGeralModal.vue";
import DepartamentoResponsavelModal
    from "@/modules/administrador/painel-de-configuracao/components/modal/DepartamentoResponsavelModal.vue";
import PatrimonioInventarioAnualModal
    from "@/modules/administrador/painel-de-configuracao/components/modal/PatrimonioInventarioAnualModal.vue";
import ConfiguracaoSimplesModal
    from "@/modules/administrador/painel-de-configuracao/components/modal/ConfiguracaoSimplesModal.vue";
import EmailConfigModal from "@/modules/administrador/painel-de-configuracao/components/modal/EmailConfigModal.vue";
import PrazoItemBemPermanenteModal
    from "@/modules/administrador/painel-de-configuracao/components/modal/PrazoItemBemPermanenteModal.vue";
import ConfiguracaoGeralLogicaModal
    from "@/modules/administrador/painel-de-configuracao/components/modal/ConfiguracaoGeralLogicaModal.vue";
import AlertaProcessoModal
    from "@/modules/administrador/painel-de-configuracao/components/modal/AlertaProcessoModal.vue";
import Swal from "sweetalert2";
import AlterarSenhaUsuarioModal
    from "@/modules/administrador/painel-de-configuracao/components/modal/AlterarSenhaUsuarioModal.vue";
import EmpresaResponsavelSistemaModal
    from "@/modules/administrador/painel-de-configuracao/components/modal/EmpresaResponsavelSistemaModal.vue";
import FrequenciaEnvioEmailModal
    from "@/modules/administrador/painel-de-configuracao/components/modal/FrequenciaEnvioEmailModal.vue";
import ConfiguracaoCamposObrigatoriosProdutoModal
    from "@/modules/administrador/painel-de-configuracao/components/modal/ConfiguracaoCamposObrigatoriosProdutoModal.vue";
import PainelConfiguracaoUsuarioForm from "@/modules/administrador/painel-de-configuracao/usuario/PainelConfiguracaoUsuarioForm.vue";
import ConfiguracaoGeralParametros from "@/modules/administrador/painel-de-configuracao/components/modal/ConfiguracaoGeralParametros.vue";
import ConfiguracaoGeralParametrosDashboard from "@/modules/administrador/painel-de-configuracao/components/modal/ConfiguracaoGeralParametrosDashboard.vue";


export default {
    components: {
        ConfiguracaoGeralParametrosDashboard,
        ConfiguracaoGeralParametros,
        PainelConfiguracaoUsuarioForm,
        ConfiguracaoCamposObrigatoriosProdutoModal,
        FrequenciaEnvioEmailModal,
        EmpresaResponsavelSistemaModal,
        AlterarSenhaUsuarioModal,
        AlertaProcessoModal, ConfiguracaoGeralLogicaModal, PrazoItemBemPermanenteModal, EmailConfigModal,
        ConfiguracaoSimplesModal,
        PatrimonioInventarioAnualModal,
        DepartamentoResponsavelModal, ConfiguracaoGeralModal,
        ManutencaoPatrimonialModal, AlmoxarifadoCentralModal, EstadoConservacaoIbpModal,
        LgFormInput,
    },
    data() {
        return {
            showPainelConfiguracaoUsuarioForm: false,
            busy: false,
            nome: "",
            configuracoes: [],
            configuracaoEdit: {
                id: null,
                ano: null,
                dataInicio: null,
                dataFim: null,
                departamentoId: null,
                departamentoNome: "",
            },
            showAlmoxarifadoCentralModal: false,
            showEmailConfigModal: false,
            showConfiguracaoSimplesModal: false,
            showDepartamentoResponsavelModal: false,
            showAlertaProcessoModal: false,
            showPrazoItemBemPermanenteModal: false,
            showConfiguracaoGeralModal: false,
            showConfiguracaoGeralParametros: false,
            showConfiguracaoGeralParametrosDashboard: false,
            showConfiguracaoGeralLogicaModal: false,
            showPatrimonioInventarioAnualModal: false,
            showEstadoConservacaoIbpModal: false,
            showManutencaoPatrimonialModal: false,
            showAlterarSenhaUsuarioModal: false,
            showEmpresaResponsavelSistemaModal: false,
            showFrequenciaEnvioEmailModal: false,
            showConfiguracaoCamposObrigatoriosProdutoModal: false,
            camposTabela: [

                { key: "tituloPropriedade", label: "Nome" },
                { label: "Valor", key: "valorPropriedadeLabel" },
                { key: "acoes", label: "", tdClass: "text-center", thClass: "text-center" },
            ],
        };
    },
    methods: {
        fecharPainelConfiguracaoUsuarioForm() {
            this.showPainelConfiguracaoUsuarioForm = false;
        },
        async buscarConfiguracao() {
            this.busy = true;
            const response = await ConfiguracaoSistemaService.buscarPorTipo(2, this.nome);
            this.busy = false;

            this.configuracoes = response.data;
        },
        async limparFiltro() {
            this.nome = "";
            this.configuracoes = [];
            try {
                const response = await ConfiguracaoSistemaService.buscarPorTipo(2, this.nome);
                this.configuracoes = response.data;
            } catch (error) {
                console.error("Erro ao buscar configuração:", error);
            }
        },
        editar(item) {
            this.configuracaoEdit = { ...item };
            switch (item.grupoConfiguracaoSistemaId) {
                case 1:
                    this.showConfiguracaoSimplesModal = true;
                    break;
                case 2:
                    this.showConfiguracaoGeralModal = true;
                    break
                case 6:
                    this.showEmailConfigModal = true;
                    break;
                case 7:
                    this.showDepartamentoResponsavelModal = true;
                    break;
                case 9:
                    this.showEmpresaResponsavelSistemaModal = true;
                    break;
                case 10:
                    this.showConfiguracaoCamposObrigatoriosProdutoModal = true;
                    break;
                case 13:
                    this.showAlertaProcessoModal = true;
                    break;
                case 14:
                    this.showPrazoItemBemPermanenteModal = true;
                    break;
                case 26:
                    this.showAlmoxarifadoCentralModal = true;
                    break;
                case 27:
                    this.showEstadoConservacaoIbpModal = true;
                    break;
                case 28:
                    this.showAlterarSenhaUsuarioModal = true;
                    break;
                case 29:
                    this.showManutencaoPatrimonialModal = true;
                    break;
                case 31:
                    this.showPatrimonioInventarioAnualModal = true;
                    break;
                case 32:
                    this.showFrequenciaEnvioEmailModal = true;
                    break;
                case 33:
                    this.showPainelConfiguracaoUsuarioForm = true;
                    break;


                case 34:
                    this.showConfiguracaoGeralParametros = true;
                    break;

                case 35:
                    this.showConfiguracaoGeralParametrosDashboard = true;
                    break;


                case 3:
                    if (item.id === 183) {
                        Swal.fire({
                            title: "Atenção",
                            text: "Este parâmetro não poderá ser modificado, pois o mesmo influenciará no cálculo do preço médio",
                            icon: "warning",
                            confirmButtonText: "OK",
                        });
                    } else {
                        this.showConfiguracaoGeralLogicaModal = true;
                    }
                    break;
                default:
                    break;
            }
        },
        onConfiguracaoSalva() {
            this.buscarConfiguracao();
            this.showConfiguracaoGeralParametrosDashboard = false;
            this.showConfiguracaoGeralParametros = false;
            this.showConfiguracaoSimplesModal = false;
            this.showEmailConfigModal = false;
            this.showAlmoxarifadoCentralModal = false;
            this.showDepartamentoResponsavelModal = false;
            this.showAlertaProcessoModal = false;
            this.showPrazoItemBemPermanenteModal = false;
            this.showConfiguracaoGeralModal = false;
            this.showConfiguracaoGeralLogicaModal = false;
            this.showPatrimonioInventarioAnualModal = false;
            this.showEstadoConservacaoIbpModal = false;
            this.showManutencaoPatrimonialModal = false;
            this.showAlterarSenhaUsuarioModal = false;
            this.showEmpresaResponsavelSistemaModal = false;
            this.showFrequenciaEnvioEmailModal = false;
            this.showConfiguracaoCamposObrigatoriosProdutoModal = false;
            this.showPainelConfiguracaoUsuarioForm = false;
        },
        onModalClose() {
            this.showConfiguracaoGeralParametros = false;
            this.showConfiguracaoGeralParametrosDashboard = false;
            this.showConfiguracaoSimplesModal = false;
            this.showEmailConfigModal = false;
            this.showAlmoxarifadoCentralModal = false;
            this.showDepartamentoResponsavelModal = false;
            this.showAlertaProcessoModal = false;
            this.showPrazoItemBemPermanenteModal = false;
            this.showConfiguracaoGeralModal = false;
            this.showConfiguracaoGeralLogicaModal = false;
            this.showPatrimonioInventarioAnualModal = false;
            this.showEstadoConservacaoIbpModal = false;
            this.showManutencaoPatrimonialModal = false;
            this.showAlterarSenhaUsuarioModal = false;
            this.showEmpresaResponsavelSistemaModal = false;
            this.showFrequenciaEnvioEmailModal = false;
            this.showConfiguracaoCamposObrigatoriosProdutoModal = false;
        },
    },
    mixins: [ListResourceMixin, ConfirmMixin],
    async mounted() {
        await this.buscarConfiguracao();
    },
};
</script>
